import { styled } from "@mui/material/styles";
import { TextField } from "@mui/material";
import { DesktopDatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import { useEffect, useState } from "react";
import { usePortalContainer } from "@/common/hooks/use-portal-container";

type BetweenPickersFilterRowProps = {
    handleChangeValueField: (startDate: any, endDate: any) => void;
    valueField?: any;
}
const StyledDesktopDatePicker = styled(DesktopDatePicker)`
    .MuiOutlinedInput-input {
        padding: 8px 12px;
        font-size: 13px;
    }
    .MuiInputBase-root {
        height: 36px;
        border-radius: 6px;
    }
`;

export const BetweenPickersFilterRow = ({ handleChangeValueField, valueField }: BetweenPickersFilterRowProps) => {
    const portalContainer = usePortalContainer();
    const [specialDateBetweenStartValue, setSpecialDateBetweenStartValue] = useState(valueField.length ?? valueField.split('isbetween')[0]);
    const [specialDateBetweenEndValue, setSpecialDateBetweenEndValue] = useState(valueField.length ?? valueField.split('isbetween')[1]);



    useEffect(() => {
        setSpecialDateBetweenStartValue(new Date(parseInt(valueField.start)));
        setSpecialDateBetweenEndValue(new Date(parseInt(valueField.end)));

    }, [valueField]);
    useEffect(() => {
        if (valueField && !Array.isArray(valueField)) {
            const startDateString = valueField.split('isbetween')[0]
            const endtDateString = valueField.split('isbetween')[1]
            setSpecialDateBetweenStartValue(new Date(parseInt(startDateString)))
            setSpecialDateBetweenEndValue(new Date(parseInt(endtDateString)))
        }
    }, [valueField]);

    const handleStartDateChange = (newValue: unknown) => {
        setSpecialDateBetweenStartValue(new Date(newValue as string | number | Date).getTime());
        handleChangeValueField(new Date(newValue as string | number | Date).getTime(), specialDateBetweenEndValue);
    };

    const handleEndDateChange = (newValue: unknown) => {
        setSpecialDateBetweenEndValue(new Date(newValue as string | number | Date).getTime());
        handleChangeValueField(new Date(specialDateBetweenStartValue).getTime(), new Date(newValue as string | number | Date).getTime());
    };

    return (
        <div style={{ display: 'flex', gap: 5 }}>
            <LocalizationProvider dateAdapter={AdapterMoment}>
                <StyledDesktopDatePicker

                    label="Start Date"
                    format="DD/MM/YYYY"
                    value={new Date(specialDateBetweenStartValue)}
                    onChange={handleStartDateChange}
                    slots={{ textField: (params: object) => <TextField {...params} /> }}
                />

                <StyledDesktopDatePicker
                    slotProps={{
                        popper: {
                            container: portalContainer as any,
                            sx: {
                                zIndex: 1600,
                            }
                        }
                    }}
                    label="End Date"
                    format="DD/MM/YYYY"
                    minDate={specialDateBetweenStartValue}
                    value={new Date(specialDateBetweenEndValue)}
                    onChange={handleEndDateChange}
                    slots={{ textField: (params: object) => <TextField {...params} /> }}
                />
            </LocalizationProvider>
        </div>
    );
};